(()=>{
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  let observer;
  if(!reduced&&'IntersectionObserver'in window){observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target)}}),{threshold:.06});document.documentElement.classList.add('motion');}
  function reveal(root=document){if(observer)root.querySelectorAll('.reveal').forEach(el=>observer.observe(el));}
  reveal();
  document.addEventListener('shopify:section:load',event=>reveal(event.target));
  document.addEventListener('shopify:section:select',event=>event.target.querySelectorAll('.reveal').forEach(el=>el.classList.add('visible')));
  const drawer=document.getElementById('HolyCartDrawer');
  const root=document.body.dataset.cartRoot||'/';
  const messages=document.body.dataset;
  let pending=false;
  let returnFocus;
  let fallback=false;
  const dialogSupported=drawer&&typeof drawer.showModal==='function';
  function openDrawer(trigger){
    if(!dialogSupported){location.href=document.body.dataset.cartUrl;return;}
    if(!drawer.open){returnFocus=trigger||document.activeElement;drawer.showModal();document.body.classList.add('cart-is-open');drawer.querySelector('[data-cart-close]').focus();}
  }
  function status(message){const el=drawer.querySelector('[data-drawer-status]');el.textContent=message;}
  function setBusy(value){
    pending=value;
    if(drawer)drawer.setAttribute('aria-busy',String(value));
    document.querySelectorAll('[data-add]').forEach(button=>{const option=button.closest('.product-info')?.querySelector('[data-variant-select]')?.selectedOptions[0];button.disabled=value||option?.dataset.available==='false';});
    drawer?.querySelectorAll('[data-cart-step],[data-cart-remove],[data-cart-quantity],[data-cart-checkout]').forEach(control=>control.disabled=value||fallback);
  }
  async function readResponse(response){
    let result;
    try{result=await response.json();}catch{throw new Error(messages.cartError);}
    if(!response.ok){const reason=result.description||result.message;throw new Error(typeof reason==='string'?reason:messages.cartError);}
    return result;
  }
  function applySection(markup,focusKey,focusAction){
    if(typeof markup!=='string')throw new Error(messages.cartRefreshError);
    const parsed=new DOMParser().parseFromString(markup,'text/html');
    const fresh=parsed.querySelector('[data-cart-content]');
    if(!fresh)throw new Error(messages.cartRefreshError);
    const scrollTop=drawer.querySelector('.drawer-items')?.scrollTop||0;
    drawer.querySelector('[data-cart-content]').replaceWith(fresh);
    const items=drawer.querySelector('.drawer-items');if(items)items.scrollTop=scrollTop;
    fallback=false;
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=fresh.dataset.count);
    setBusy(pending);
    if(focusKey&&drawer.open){const row=[...drawer.querySelectorAll('[data-line-key]')].find(el=>el.dataset.lineKey===focusKey);const target=row?.querySelector(focusAction)||drawer.querySelector('[data-cart-close]');target.focus();}
    document.dispatchEvent(new CustomEvent('holy:cart-updated',{detail:{count:Number(fresh.dataset.count)}}));
  }
  async function refresh(result,focusKey,focusAction){
    const markup=result?.sections?.['cart-drawer'];
    if(markup){applySection(markup,focusKey,focusAction);return;}
    const url=new URL(location.href);url.searchParams.set('sections','cart-drawer');url.hash='';
    const response=await fetch(url,{headers:{Accept:'application/json'},cache:'no-store'});
    const sections=await readResponse(response);
    applySection(sections['cart-drawer'],focusKey,focusAction);
  }
  function renderFallback(){
    fallback=true;
    const content=drawer.querySelector('[data-cart-content]');content.replaceChildren();
    const p=document.createElement('p');p.className='drawer-fallback';p.textContent=messages.cartRefreshError;
    const link=document.createElement('a');link.className='button accent';link.href=document.body.dataset.cartUrl;link.textContent=messages.cartView;
    content.append(p,link);
    status(messages.cartRefreshError);
  }
  if(drawer){
    drawer.addEventListener('close',()=>{document.body.classList.remove('cart-is-open');if(returnFocus?.isConnected)returnFocus.focus();else document.querySelector('[data-cart-open]')?.focus();});
    drawer.addEventListener('click',event=>{if(event.target===drawer)drawer.close();});
  }
  document.addEventListener('click',async event=>{
    const menuLink=event.target.closest('.mobile-menu a');if(menuLink)menuLink.closest('details').open=false;
    const opener=event.target.closest('[data-cart-open]');
    if(opener&&dialogSupported){event.preventDefault();openDrawer(opener);if(!pending){setBusy(true);try{await refresh();status('');}catch{renderFallback();}finally{setBusy(false);}}return;}
    if(event.target.closest('[data-cart-close]')){drawer?.close();return;}
    const button=event.target.closest('[data-cart-step],[data-cart-remove]');
    if(!button||pending)return;
    const row=button.closest('[data-line-key]');const input=row.querySelector('[data-cart-quantity]');
    const quantity=button.hasAttribute('data-cart-remove')?0:Math.max(0,Number(input.value)+Number(button.dataset.cartStep));
    const selector=button.hasAttribute('data-cart-remove')?'[data-cart-remove]':`[data-cart-step="${button.dataset.cartStep}"]`;
    await changeLine(row.dataset.lineKey,quantity,selector);
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mobile-menu[open]').forEach(menu=>menu.open=false);});
  document.addEventListener('change',async event=>{
    if(event.target.matches('[data-variant-select]')){
      const option=event.target.selectedOptions[0];if(!option)return;
      const section=event.target.closest('.product-info');const price=section.querySelector('[data-price]');if(price)price.textContent=option.dataset.price;
      const button=section.querySelector('[data-add]');const available=option.dataset.available==='true';button.disabled=pending||!available;button.textContent=available?button.dataset.addLabel:button.dataset.soldLabel;
    }
    if(event.target.matches('[data-cart-quantity]')&&!pending){const value=Number(event.target.value);if(event.target.value.trim()===''||!Number.isInteger(value)||value<0){event.target.reportValidity();return;}await changeLine(event.target.closest('[data-line-key]').dataset.lineKey,value,'[data-cart-quantity]');}
  });
  async function changeLine(key,quantity,focusAction){
    if(pending)return;
    setBusy(true);status(messages.cartUpdating);
    let committed=false;
    try{
      const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['cart-drawer'],sections_url:location.pathname+location.search})});
      const result=await readResponse(response);committed=true;await refresh(result,key,focusAction);status(messages.cartUpdated);
    }catch(error){
      if(committed)renderFallback();else{status(error.message);try{await refresh();}catch{renderFallback();}}
    }finally{setBusy(false);if(drawer.open){const row=[...drawer.querySelectorAll('[data-line-key]')].find(el=>el.dataset.lineKey===key);(row?.querySelector(focusAction)||drawer.querySelector('[data-cart-close]')).focus();}}
  }
  document.addEventListener('submit',async event=>{
    const form=event.target;if(!form.matches('[data-ajax-product]')||!dialogSupported)return;
    event.preventDefault();if(pending)return;
    const button=form.querySelector('[data-add]');const feedback=form.querySelector('[data-form-feedback]');
    const original=button.textContent;const trigger=event.submitter||button;
    setBusy(true);button.textContent=messages.adding;
    if(feedback){feedback.hidden=false;feedback.textContent=messages.adding;}
    let committed=false;
    try{
      const data=new FormData(form);data.set('sections','cart-drawer');data.set('sections_url',location.pathname+location.search);
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
      const result=await readResponse(response);committed=true;
      await refresh(result);openDrawer(trigger);status(messages.cartAdded);
      if(feedback){feedback.textContent=messages.cartAdded;}
    }catch(error){
      if(committed){renderFallback();openDrawer(trigger);if(feedback)feedback.textContent=messages.cartAdded;}
      else if(feedback){feedback.textContent=error.message;}
    }finally{button.textContent=original;setBusy(false);}
  });
})();
